import { ReactNode } from 'react';
import { useWizard } from 'react-use-wizard';
import { useSetAtom } from 'jotai';
import { useTranslation } from 'next-i18next';
import { GlobeEuropeAfricaIcon } from '@heroicons/react/24/outline';

import { Heading } from '@restworld/ui-ds-base';
import { cn, ItalyMapIcon, MarkerPinIcon } from '@restworld/utils-common';
import { useAuth } from '@restworld/feature-authentication';

import { StepWrapper, areaSelectionAtom } from '../job-explorer-save-research-v2';

export const RegionalAreaSelection = () => {
  const { isAuthenticated } = useAuth();
  const { goToStep, nextStep } = useWizard();
  const setAreaSelection = useSetAtom(areaSelectionAtom);
  const { t } = useTranslation('job-explorer-page');
  return (
    <StepWrapper>
      <div data-cy="regional-selection-area" className="flex flex-col gap-6">
        <div className="flex flex-col gap-2">
          <Heading size={3} className="leading-[28.8px]" testId="save-research-title">
            {t('where_looking_for_next_job')}
          </Heading>
          <Heading size={5} weight="normal" color="muted" className="leading-[24px]">
            {!isAuthenticated ? t('tried_of_searching') : t('chose_area_start_search_jp')}
          </Heading>
        </div>
        <div className="flex flex-col md:flex-row gap-4 items-center justify-center w-full">
          <SelectCard
            title={t('italy_and_abroad')}
            icon={<GlobeEuropeAfricaIcon className="h-7 w-7" />}
            handleClick={() => {
              setAreaSelection('italy_and_abroad');
              goToStep(2);
            }}
            testId="specific-area"
          />
          <SelectCard
            title={t('all_Italy')}
            icon={<ItalyMapIcon />}
            handleClick={() => {
              goToStep(2);
              setAreaSelection('whole_italy');
            }}
            testId="all-italy"
          />
          <SelectCard
            title={t('specific_area')}
            icon={<MarkerPinIcon />}
            handleClick={() => {
              setAreaSelection('regional');
              nextStep();
            }}
            testId="specific-area"
          />
        </div>
      </div>
    </StepWrapper>
  );
};
const SelectCard = ({
  title,
  icon,
  handleClick,
  testId,
}: {
  title: string;
  icon: ReactNode;
  handleClick: () => void;
  testId?: string;
}) => (
  <StyledSelectCard onClick={() => handleClick()} data-cy={testId}>
    <span className="flex flex-col gap-3 items-center text-center justify-center">
      {icon}
      {title}
    </span>
  </StyledSelectCard>
);

const StyledSelectCard = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div
    className={cn(
      'cursor-pointer border border-primary-50 bg-primary-50 w-full md:w-1/2 min-h-[132px] flex items-center justify-center rounded-lg p-4 hover:ring-4 hover:ring-primary-200 hover:border hover:border-primary-800 transition ease-in-out duration-200',
      className
    )}
    {...props}
  />
);
